var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedininline = function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.106 0H.783A.767.767 0 0 0 0 .788v16.537c0 .338.335.675.783.675h16.434a.767.767 0 0 0 .783-.788V.788C17.888.338 17.553 0 17.106 0M5.255 15.3H2.683V6.75h2.683v8.55zm-1.23-9.675c-.895 0-1.565-.787-1.565-1.575 0-.9.67-1.575 1.565-1.575S5.59 3.15 5.59 4.05c-.112.788-.783 1.575-1.565 1.575m11.18 9.675h-2.683v-4.163c0-1.012 0-2.25-1.342-2.25-1.341 0-1.565 1.125-1.565 2.25v4.275H6.932V6.75h2.571v1.125c.336-.675 1.23-1.35 2.46-1.35 2.683 0 3.13 1.8 3.13 4.05V15.3z"
  })));
};
export default SvgLinkedininline;